// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1Uf4c","boxTitle":"Qualiphy_boxTitle__gxP9F","box":"Qualiphy_box__ryzku","toggleWrap":"Qualiphy_toggleWrap__23qUW"};